<template>
    <div class="formulario-editor-container" style="borderradius: 8px; background: #fafafa; box-shadow: none; padding: 24px">
        <slot name="overlaySelecao" />
        <form @submit.prevent class="formulario-frame-wrapper">
            <div class="mb-2" v-for="i in 4" :key="i">
                <div class="campo-placeholder" :style="props.estilos?.campo">Configurado na Próxima etapa</div>
            </div>
            <button type="button" class="mt-2 botao-placeholder" :style="props.estilos?.botao"></button>
        </form>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';

const props = defineProps({
    estilos: {
        type: Object,
        default: () => ({
            container: {
                borderRadius: '8px',
                background: '#fafafa',
                boxShadow: 'none',
            },
            campo: {
                borderRadius: '4px',
                border: '1px solid #ccc',
                padding: '8px',
            },
            botao: {
                borderRadius: '4px',
                backgroundColor: '#0f97c7',
                color: '#fff',
                padding: '10px 20px',
            },
        }),
    },
});

const emit = defineEmits(['update:props']);

const propsAtualizados = computed(() => ({
    estilos: props.estilos,
}));

emit('update:props', { ...propsAtualizados.value });
</script>

<style scoped>
.formulario-editor-container {
    width: 100%;
    height: 100%;
    min-height: 80px;
    max-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    border-radius: 8px;
}
.formulario-frame-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.campo-placeholder {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    color: #1e88a8;
    text-align: center;
    padding: 12px 0;
    margin-bottom: 8px;
    font-size: 1.1em;
}
.botao-placeholder {
    width: 60%;
    height: 38px;
    background: #149dcc;
    border: none;
    border-radius: 6px;
    margin: 12px auto 0 auto;
    display: block;
}
</style>
